import { ReactNode, Suspense, useState } from 'react';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import ChatAvatarCanvas from '~/components/ChatAvatar/Canvas/MysteryCanvas';
import ChatPageLoadingLayout from '~/components/common/ChatPageLoadingLayout/ChatPageLoadingLayout';
import { AvatarInfo, ChatRoomBackgroundUrl, GuessingStep } from '~/types';
import { AvatarLoadFailFallbackLayout } from '../ChatConcept/Background';

interface ThreeJSBackgroundProps {
  step: GuessingStep;
  avatarInfo: AvatarInfo[] | null;
  backgroundInfo: ChatRoomBackgroundUrl[];
  customChatRoomLoading?: ReactNode;
}

export default function ThreeJSBackground({
  step,
  avatarInfo,
  backgroundInfo,
}: ThreeJSBackgroundProps) {
  const robotAvatars = avatarInfo?.filter((avatar) => avatar.id === 'robot');
  const nonRobotAvatars = avatarInfo?.filter((avatar) => avatar.id !== 'robot');

  const displayedAvatars =
    step !== 'Introduction' ? nonRobotAvatars : robotAvatars;

  const robotBackground = backgroundInfo.filter((bg) => bg.id === 'robot');
  const nonRobotBackground = backgroundInfo.filter((bg) => bg.id !== 'robot');

  const displayedBackground =
    step !== 'Introduction' && nonRobotBackground.length > 0
      ? nonRobotBackground[0].url
      : robotBackground.length > 0
      ? robotBackground[0].url
      : '/park.jpg';

  return (
    <div>
      <ChatPageLoadingLayout />
      <Container>
        <Sentry.ErrorBoundary fallback={<AvatarLoadFailFallbackLayout />}>
          <Suspense fallback={<AvatarLoadFailFallbackLayout />}>
            <ChatAvatarCanvas
              avatars={displayedAvatars}
              background={displayedBackground}
            />
          </Suspense>
        </Sentry.ErrorBoundary>
      </Container>
    </div>
  );
}

export const Container = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
`;
